<template>
  <div id="editDealerContainer">
    <dealer :dealer-id="this.$route.params.id" />
  </div>
</template>

<script>
import Dealer from './Dealer'
export default {
  components: {
    Dealer
  }
}
</script>
